<template>
	<div>
		<no-data v-if="!surveyList.length && dataLoadState"></no-data>
		<div class="notification-header shadow-bottom" v-if="surveyList.length > 0 &&
			surveyList[0].status &&
			surveyList[0].status.value === 'LEARNING'
			">
			<div class="container container--narrow pdt-16 pdb-16">
				<div class="d-flex align-items-center">
					<span class="notification-icon min-w-36 min-h-24"><i
							class="material-icons t-color-secondaryBtnText">notifications</i></span>
					<div class="t-body2 font-m l-spacing42 pdl-16">
						{{ $t("1961") }}
					</div>
				</div>
			</div>
		</div>
		<div class="container container--narrow pdt-30" v-if="surveyList.length">
			<div class="mdc-card mgb-50 pdb-8">
				<div class="t-headline7 font-m mgb-16 mgr-12 pdt-24 pdl-24">
					{{ $t("1962") }}
				</div>
				<div v-for="(survey, index) in surveyList" :key="index" tabindex="0"
					class="d-flex pdt-16 mgl-24 position-relative cursor-pointer" :class="survey.status && survey.status.value === 'COMPLETION'
							? 'opacity-class'
							: 'ripple-item'
						" @click="
		takeSurvey(
			survey,
			survey.id,
			survey.respondentId,
			survey.type.value
		)
		" @keypress="
		takeSurvey(
			survey,
			survey.id,
			survey.respondentId,
			survey.type.value
		)
		">
					<div class="">
						<img src="../../../images/survey-list-icon.svg" alt="" class="icon52" />
					</div>
					<div class="flex-grow-1 pdl-20">
						<div class="mgb-18">
							<div class="t-body1 mgb-4 font-r pdr-24 l-spacing48">
								{{ survey.name }}
							</div>
							<div class="t-body6 font-r pdr-24 l-spacing45 t-color-bodyGrayA"
								v-if="survey.status && survey.status.value === 'LEARNING'">
								<span> {{ $t("3006") }} </span>
							</div>
							<div class="t-body6 font-r pdr-24 l-spacing45 t-color-bodyGrayA"
								v-if="survey.status && survey.status.value === 'COMPLETION'">
								<span> {{ $t("3060") }} </span>
							</div>
							<div class="t-body6 font-r pdr-24 l-spacing45 t-color-bodyGrayA"
								v-if="survey.status && survey.status.value === 'WAITING'">
								<span> {{ $t("1963") }} </span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
/**
 * 나의 학습 상세 - 정규평가 탭 컴포넌트(my learning view - exam tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from "@/api/httpService";
import learnApi from "@/api/learnApi.js";
import NoData from "../../common/NoDataSurveyLesson.vue";
import { MDCRipple } from "@material/ripple";
export default {
	components: {
		"no-data": NoData,
	},
	data() {
		return {
			surveyList: [],
			dataLoadState: false,
			addOpacityClass: false,
		};
	},
	mounted() {
		//alert(this.$route.query.status)
		this.fetchData();
	},

	updated() {
		const ripples = [].map.call(
			document.querySelectorAll(".ripple-item"),
			function (el) {
				let ripple = new MDCRipple.attachTo(el);
				return ripple;
			}
		);
	},

	methods: {
		// 시험정보 API 호출 및 데이터 설정(get exam list data)
		fetchData() {
			let responseData = null;
			let params = this.setParams();

			//this.$showLoading(this.$refs.examList)
			learnApi
				.learnViewSurveys(params)
				.then((response) => {
					this.surveyList = response.data.data;
					if (response.data.data.length > 0) {
						this.dataLoadState = false;
					} else {
						this.dataLoadState = true;
					}
					if (
						this.surveyList[0].status &&
						this.surveyList[0].status.value === "COMPLETION"
					) {
						this.addOpacityClass = true;
					} else {
						this.addOpacityClass = false;
					}
					//this.$hideLoading()
					//console.log('this.surveyList.length',response.data.data)

					// let applicableExamList = _.filter(this.surveyList, function(o) { return o.status === 'APPLICABLE' || o.status === 'REAPPLICATION' })

					// if (applicableExamList) {
					//     let examineeId = _.head(applicableExamList).examineeId
					//     this.setExamineeId(examineeId)
					// }
				})
				.catch((err) => { });
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				learnId: this.$route.params.learnId,
			};
			return params;
		},

		// 시험응시(move take exam)
		takeSurvey(survey, id, respondentId, surveyDistributionType) {
			// console.log("take survey Id dk",survey)
			let params = {
				distId: id,
				respondentId: respondentId,
			};
			if (survey.status && survey.status.value === "LEARNING") {
				this.$confirm({
					title: this.$t("746"), // 학습을 중단한 강의입니다.
					content: this.$t("747"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
					accept: this.$t("749"), // 확인
					cancel: this.$t("748"),
				})
					.then(() => {
						this.$router.push({
							name: "IndependentSurveyIntro",
							params: params,
							query: {
								status: this.$route.query.status,
								learnId: this.$router.currentRoute.params.learnId,
								distributionType: surveyDistributionType,
								type: "LEARN",
							},
						});
					})
					.catch(() => { });
			} else if (survey.status && survey.status.value === "WAITING") {
				this.takeNotSurvey();
			}
		},
		takeNotSurvey() {
			this.$alert({
				content: this.$t("3041"),
				accept: this.$t("3042"),
			})
				.then(() => { })
				.catch(() => { });
		},
		// setMissionId(examineeId) {
		//     this.$emit('setExamineeId', examineeId)
		// }
	},
};
</script>
<style scoped>
.opacity-class {
	opacity: 0.6 !important;
	cursor: default !important;
}
</style>